import { MetadataContent } from '@jutro/legacy/uiconfig';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Loader } from '@jutro/components';
import ClaimListComponent from '../../components/ClaimListComponent/ClaimListComponent';
import metadata from './ClaimList.metadata.json5';
import styles from './ClaimList.module.scss';

function ClaimList() {
    const authData = useAuthentication()
    const authHeader = _.get(authData, 'authHeader');
    const [isLoading, setLoadingState] = useState(true);

    useEffect(() => {
        if (authHeader) {
            setLoadingState(false);
        }
    }, [authHeader])

    const overrides = {};
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            claimlistcomponent: ClaimListComponent,
        },
    };

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
}

export default withRouter(ClaimList);
